<div nz-row class="login-box" nzType="flex" nzJustify="center">
    <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
        <h1 class="text">{{ "app.label.welcome-verify-otp" | translate }}</h1>
        <p class="mt-lg mob-mt-lg mb-lg mob-mb-lg">
            {{ "app.otp.login.title" | translate }}
        </p>
        <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()" nzLayout="vertical">
            <!-- opt -->
            <nz-form-item>
                <cargoes-form-label [labelName]="{labels:['app.label.otp'| translate]}" [isMandatory]="true"></cargoes-form-label>
                <nz-form-control class="formContol" [nzErrorTip]="errorTplPassword">
                    <input nz-input id="opt" type ="password" autocomplete="off" formControlName="opt" [placeholder]="'app.label.otp' | translate"
                    [nzSize]="'large'">
                </nz-form-control>
            </nz-form-item>
            <!-- end of the opt -->
            <nz-form-item>
                <nz-form-control>
                    <button class="mb-lg" nz-button [nzSize]="'large'" [nzType]="'primary'" [nzBlock]="true" [nzLoading]="loading"
                    (click)="goto()">
                        {{ "app.action.verify" | translate }}
                    </button>
                </nz-form-control>
            </nz-form-item>
        </form>
    </nz-card>
</div>
<ng-template #errorTplPassword let-control>
    <ng-container *ngIf="control.hasError('required')">
        <div>{{ "app.login.opt.required" | translate }}</div>
    </ng-container>
    <ng-container *ngIf="!control.hasError('pattern') && control.hasError('maxlength')">
        <div>{{ 'app.label.opt.max.validation' | translate }}</div>
    </ng-container>
    <ng-container *ngIf="!control.hasError('pattern') && control.hasError('minlength')">
        <div>{{ 'app.label.opt.min.validation' | translate }}</div>
    </ng-container>
    <ng-container *ngIf="control.hasError('pattern')">
        <div>{{'app.label.opt.pattern.validation' | translate }}</div>
    </ng-container>
</ng-template>